import styled from "styled-components"
import { Link } from "react-router-dom";

export const LinkApp = styled(Link)`

{
    display: flex;
    justify-content: flex-start;
    text-decoration: none;
    color: #A66B56;
}

&:hover{
    
    color: #5BCCD9;
}

`
